var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextbtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "#D6D6D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8069 23.1931C30.2532 23.6394 30.2532 24.3642 29.8069 24.8104L22.952 31.6653C22.5057 32.1116 21.781 32.1116 21.3347 31.6653C20.8884 31.219 20.8884 30.4943 21.3347 30.048L27.3827 24L21.3383 17.952C20.892 17.5057 20.892 16.781 21.3383 16.3347C21.7846 15.8884 22.5093 15.8884 22.9556 16.3347L29.8104 23.1896L29.8069 23.1931Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextbtn);
export default __webpack_public_path__ + "static/media/nextbtn.564ff414830fa6d0ef78bdaa2bcae0b1.svg";
export { ForwardRef as ReactComponent };